import React from "react";
import prettyDateString from "./prettyDateString";
import { Descriptions } from "antd";
import properCase from "./properCase";

export default function descriptionList(data, title: string | null = null) {
  const descriptions = [];
  if (data === undefined || data === null) {
    data = {};
  }

  for (let field in data) {
    let value = data[field];
    if (value && field != "__typename") {
      if (field == "createdAt" || field == "updatedAt") {
        value = prettyDateString(value);
      }
      descriptions.push(
        <Descriptions.Item key={field} label={<b>{properCase(field)}</b>}>
          {value}
        </Descriptions.Item>
      );
    }
  }

  if (title) {
    return <Descriptions title={title}>{descriptions}</Descriptions>;
  } else {
    return <Descriptions>{descriptions}</Descriptions>;
  }
}
